import * as ACTION_TYPES from './types';

const initialState = {
  show: false,
  location: {
    x: null,
    y: null,
  },
  type: null,
  menuArgs: undefined,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.CONTEXT_MENU_SHOW:
      return {
        ...state,
        show: true,
        ...payload,
      };
    case ACTION_TYPES.CONTEXT_MENU_HIDE:
      return initialState;
    default:
      return state;
  }
}
